import { ActivityBranch, UpdateActivityBranch } from '@/entities/activityBranch';
import { Api } from './api/axios-config';
export class ActivityBranchService{
  private static api = Api();

  public static async getAllActivityBranch(): Promise<ActivityBranch[] | null>{
    const response = await this.api.get<any>('/activity-branch');
        
    if(response.status === 200){
      return response.data.map((data: any)=>({
        id: data.id,
        name: data.name
      }));
    }
    return null;
  }

  public static async createActivityBranch(newActivityBranch:{name: string}):Promise<ActivityBranch | null>{
    const response = await this.api.post<any>('/activity-branch', newActivityBranch);
    if(response.status === 200){
      return {
        id: response.data.id,
        name: response.data.name,
        contactNumber: response.data.contactNumber                
      };
    }
    return null; 
  }

  public static async updateManyActivityBranch(activityBranchs: UpdateActivityBranch[]):Promise<ActivityBranch[] | null>{
    const response = await this.api.post<any>('/activity-branch/update-many-activity-branch', {
      activityBranchs: activityBranchs.map((activityBranch)=>({
        id: activityBranch.id,
        name: activityBranch.name
      }))
    });
    if(response.status === 201){
      return response.data.map((data: any) => ({
        id: data.id,
        name: data.name,
      }));
    }
    return null;
  }

  public static async searchActivityBranch(contain: string): Promise<ActivityBranch[] | null>{
    const response = await this.api.post<any>('/activity-branch/search', { contain });
    if(response.status === 201){
      return response.data.map((data: any) => ({
        id: data.id,
        name: data.name,
      }));
    }
    return null;
  }

  public static async deleteActivityBranch(id: number):Promise<ActivityBranch | null>{
    const response = await this.api.delete<any>(`/activity-branch/${id}`);
    if(response.status === 200){
      return {
        id: response.data.id,
        name: response.data.name,
        contactNumber: response.data.contactNumber   
      };
    }
    return null;
  }
}
